import React, { useState } from "react";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import { requestFeature } from "../../../ApiServices/ApiServices";
import { handleError, handleSuccess } from "../../../Utils";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "../../../provider/authProvider";

const RequestFeature = ({setIsFeatureRequestPopUpVisible}) => {
  const [featureTitle, setFeatureTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const email = getEmail();
  const { getUserName } = useAuth();
  const name = getUserName();
  const [hasRequested, setHasRequested] = useState(false);

  const handleTitleChange = (e) => {
    if (e.target.value.length <= 100) {
      setFeatureTitle(e.target.value);
    }
  };

  const handleDescriptionChange = (e) => {
    if (e.target.value.length <= 2000) {
      setDescription(e.target.value);
    }
  };

  const handleFileChange = (event) => {
    const doc = event.target.files[0];
    if (doc) {
      if (doc.size > 5 * 1024 * 1024) {
        handleError("File size must be less than 5MB!");
        setFile(null); // Reset the file
      } else {
        setFile(doc);
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!featureTitle || !description) {
        return handleError("Please fill all the details");
      }
      setHasRequested(true);
      const formData = new FormData();
      formData.append("email", email);
      formData.append("name", name);
      formData.append("description", description);
      formData.append("featureTitle", featureTitle);
      if (file) {
        formData.append("file", file);
      }
      const response = await requestFeature(formData);
      handleSuccess(response.message);
      setFeatureTitle("");
      setDescription("");
      setFile(null);
      setHasRequested(false);
      setIsFeatureRequestPopUpVisible(false);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="w-full sm:w-[70%] lg:w-[50%] bg-white px-6 pb-6 rounded-lg shadow-lg relative">
        <span className="absolute right-1 cursor-pointer" onClick={()=>setIsFeatureRequestPopUpVisible(false)}>
          <CloseIcon />
        </span>
        <div className="flex mb-4 border-b-2 pb-4 pt-6">
          <h1 className="text-3xl font-semibold text-gray-800">Feedback</h1>
        </div>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="flex flex-col space-y-2">
            <label
              htmlFor="featureTitle"
              className="text-gray-600 text-sm font-medium m-0 flex justify-between px-1"
            >
              <span>Feature Title</span>
              <span className="text-[12px]">{featureTitle.length}/100</span>
            </label>
            <input
              type="text"
              id="featureTitle"
              placeholder="Enter feature title"
              value={featureTitle}
              onChange={(e) => handleTitleChange(e)}
              className="m-0 w-full border-gray-300 border p-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 text-gray-600"
            />
          </div>

          <div className="flex flex-col space-y-2">
            <label
              htmlFor="description"
              className="text-gray-600 text-sm font-medium m-0 flex justify-between px-1"
            >
              <span>Description</span>
              <span className="text-[12px]">{description.length}/2000</span>
            </label>
            <textarea
              id="description"
              placeholder="Describe the feature in detail"
              value={description}
              onChange={(e) => handleDescriptionChange(e)}
              className="m-0 w-full border-gray-300 border p-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 text-gray-600"
              rows="5"
            ></textarea>
          </div>

          <div className="flex sm:flex-row gap-4   justify-between items-center">
            <div className="flex items-center ">
              <label
                htmlFor="file-upload"
                className="secondary-btn text-[14px] mt-1"
              >
                Upload
              </label>
              <input
                id="file-upload"
                type="file"
                className="hidden"
                onChange={handleFileChange}
              />
              {file && (
                <p className="text-sm text-gray-600">Uploaded: {file.name}</p>
              )}
            </div>

            <button type="submit" className="primary-btn">
              {hasRequested?"Sending...":"Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestFeature;
